import Cookies from 'js-cookie';

export default class CompareProducts
{
  constructor()
  {
    this.setVars();
  
    window.addEventListener('compare_product_reinit', () => {
      this.setVars();
    })
  }
  
  setVars()
  {
    this.settings = {
      wrapper: 'data-compare',
      button: 'data-compare-button',
      button_label_start: 'data-compare-button-start',
      button_label_redirect: 'data-compare-button-redirect',
      label: 'data-compare-label',
      redirect: 'data-compare-redirect',
      product: 'data-compare-product',
      remove_product: 'data-remove-product',
    };
    
    this.compare = document.querySelector(`[${this.settings.wrapper}]`);
    if (!this.compare) return;
    
    this.button = this.compare.querySelector(`[${this.settings.button}]`);
    if (this.button) {
      this.label = this.button.querySelector(`[${this.settings.label}]`);
      this.label_start = this.button.getAttribute(this.settings.button_label_start);
      this.label_redirect = this.button.getAttribute(this.settings.button_label_redirect);
      this.url_redirect = this.button.getAttribute(this.settings.redirect);
      this.current_label = this.label_start;
    }
    
    this.remove = document.querySelectorAll(`[${this.settings.remove_product}]`);
    this.products = [];
    this.getCookie();
    
    this.setEvents();
  }
  
  setEvents()
  {
    if(this.remove.length) {
      this.remove.forEach(product => {
        product.addEventListener('click', () => {
          this.manageProducts(product.getAttribute(this.settings.remove_product));
          setTimeout(() => {
            window.location.reload(true)
          })
        })
      });
    }
    
    if (this.button) {
      this.button.addEventListener('click', (e) => {
        this.addClassBody();
        this.selectedProduct();
    
        if (this.current_label === this.label_start) {
          e.preventDefault();
          this.changeLabel();
        }
      });
  
      window.addEventListener('compare_product_reload_event_click', () => {
        this.setClickOnProducts();
      })
  
      this.setClickOnProducts();
    }
  }
  
  setClickOnProducts() {
    document.querySelectorAll(`[${this.settings.product}]`).forEach((product) => {
      product.addEventListener('click', (e) => {
        if (document.querySelector('body').hasClass('compare_active')) {
          e.preventDefault();
          e.stopPropagation();
          product.toggleClass('compare_active_product');
          const product_id = product.getAttribute(this.settings.product);
        
          this.manageProducts(product_id);
          this.changeLabel();
        }
      })
    })
  }
  
  changeLabel() {
    if (this.products.length > 0 && this.current_label !== this.label_redirect) {
      this.current_label = this.label_redirect;
      this.label.innerHTML = this.label_redirect;
      this.button.setAttribute('href', this.url_redirect);
    } else if (this.products.length === 0)  {
      this.current_label = this.label_start;
      this.label.innerHTML = this.label_start;
      this.button.setAttribute('href', '#');
    }
  }
  
  selectedProduct() {
    document.querySelectorAll(`[${this.settings.product}]`).forEach((product) => {
      if (this.products.includes(product.getAttribute(this.settings.product))) {
        product.addClass('compare_active_product');
      }
    });
  }
  
  manageProducts(product_id) {
    if (this.products.includes(product_id)) {
      this.products.remove(product_id);
      this.openPopupRemove();
    } else {
      this.products.push(product_id);
      this.openPopupAdd();
    }
    
    this.setCookie();
  }
  
  openPopupAdd() {
    const wishlistCounter = document.querySelector('[data-counter-wishlist]');
    
    if (!wishlistCounter.hasClass('active') && this.products.length > 0) {
      wishlistCounter.addClass('active')
    }
    
    wishlistCounter.setAttribute('data-counter-wishlist', this.products.length);
    const popup = document.querySelector('[data-product-compare-add]');
    popup.addClass('active');
    
    setTimeout(() => {
      popup.removeClass('active');
    }, 3000);
  }
  
  openPopupRemove() {
    const wishlistCounter = document.querySelector('[data-counter-wishlist]');
    wishlistCounter.setAttribute('data-counter-wishlist', this.products.length);
  
    if (wishlistCounter.hasClass('active') && this.products.length === 0) {
      wishlistCounter.removeClass('active')
    }
  }
  
  getCookie() {
    const cookie = Cookies.get('woo_compare_product');
    if (cookie) {
      this.products = cookie.split(' ').filter((el) => { return el != ''; });
    }
  }
  
  setCookie() {
    if (this.products) {
      Cookies.set('woo_compare_product', this.products.join(' '))
    } else {
      Cookies.remove('woo_compare_product');
    }
  }
  
  addClassBody() {
    document.querySelector('body').addClass('compare_active');
  }
  
  removeClassBody() {
    document.querySelector('body').removeClass('compare_active');
  }
}
